import { log, logLevel } from "../logging";
import { returnCodes } from "../return-codes";
import { defaultTimeout, twentyFourDays, timedPromise} from "../utility";
import { isWebExtensionsEnabled } from "../fingerprinting";

export function callBiscExtensions(calledMethodName, transformer, options, specificTimeout) {
    if (!isWebExtensionsEnabled()) {
        throw new Error(returnCodes.ServiceUnavailable);
    }

    let callPromise = new Promise((resolve, reject) => {
        //Create handler for the expected response
        let messageHandler = ((tf) => {
            let handler = event => {
                //Clean up
                document.removeEventListener("content-script-response", handler);
                //Validate
                let valid =     event.target == document
                            &&  event.detail
                            &&  event.detail.direction == "from-content-script"
                            &&  event.detail.message
                            ;
                if (!valid) {
                    log(`[${calledMethodName}] Page Script - received invalid message from content script`, logLevel.Debug);
                    return; 
                }
                //Process
                let msg = event.detail.message;
                log(`[${calledMethodName}] Page Script - received message from content script ${JSON.stringify(msg)}`, logLevel.Debug);
                //success
                if (msg.error_code == 0) {
                    return resolve(tf ? tf(msg.response) : msg.response);
                }
                //special failure case
                if (calledMethodName == 'getExtensionVersion' && msg.error_code == -1) {
                    return resolve("0.0.0");
                }
                //special failure case
                if (calledMethodName == 'getIsabelCardVersion' && msg.error_code == -1) {
                    return reject(new Error(JSON.stringify(msg)));
                }
                //general failure case
                return reject(new Error(msg.error_code));
            };

            return handler;
        })(transformer);
        
        //Prepare for reponse from content script
        document.addEventListener("content-script-response", messageHandler, false);

        //Send message to content script
        let req2bisc = {method: calledMethodName, parameters:options};
        log(`req2bisc = ${JSON.stringify(req2bisc)}`, logLevel.Debug);
        let custEvent = new CustomEvent("page-script-request", { 'detail': {direction:"from-page-script", message:req2bisc} });
        document.dispatchEvent(custEvent);
    });

    let theTimeout = specificTimeout? specificTimeout: defaultTimeout;
    return timedPromise(theTimeout, callPromise).catch( error => {
        log(error.message + ' in ' + calledMethodName, logLevel.Error);
        return Promise.reject(error);
    });
}

export async function getExtensionVersion(optionalTimeout) {
    let extVersion = await callBiscExtensions("getExtensionVersion", undefined, undefined, optionalTimeout);

    log(`[getExtensionVersion] extension version: ${extVersion}`, logLevel.Debug);
    return extVersion;
}


export async function getApiVersion(optionalTimeout) {
    let version = await callBiscExtensions("version", res => res.version, undefined, optionalTimeout);

    log(`[getApiVersion] current api version: 2.1.59`, logLevel.Debug);
    return version;
}

export async function isSecurityComponentsAvailable(optionalTimeout) {
    let isAvailable = (await getApiVersion(optionalTimeout)) ? true : false;
    log("[isSecurityComponentsAvailable] is bisc supported: "+isAvailable, logLevel.Debug);
    return isAvailable;
}

export async function getSecurityComponentsVersion(optionalTimeout) {
    //Call Bisc extensions
    return callBiscExtensions("getSecurityComponentsVersion"
                , resp => resp.version, undefined, optionalTimeout);
}

export async function getCardReaders() {
    let cardReaders = await callBiscExtensions("getCardReaders", resp => resp.card_readers);

    return cardReaders == "none" ? [] : cardReaders;
}

export async function isCardReaderAvailable() {
    let cardReaders = await getCardReaders();
    return cardReaders.length > 0;
}

export async function launchCardActivator(options) {
    //Call Bisc extension
    return callBiscExtensions("launchCardActivator", undefined, { cmd_line_args: options }, twentyFourDays);
}

export async function decryptPin(data, certificate) {
    let pin = await callBiscExtensions("decryptPin", resp => resp.pin, {data:data, certificate:certificate});

    log(`[decryptPin] pin number: ${pin}`, logLevel.Debug);
    return pin;
}